import { render, staticRenderFns } from "./CustomerNotesSidebar.vue?vue&type=template&id=3fc5ee86&scoped=true"
import script from "./CustomerNotesSidebar.vue?vue&type=script&lang=js"
export * from "./CustomerNotesSidebar.vue?vue&type=script&lang=js"
import style0 from "./CustomerNotesSidebar.vue?vue&type=style&index=0&id=3fc5ee86&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3fc5ee86",
  null
  
)

export default component.exports